<div
  class="row section clinical-feedback-section"
  formGroupName="patientDetailsForm"
>
  <div class="section-container">
    <div class="row section-row">
      <div class="col section-col">
        <h5 class="section-heading">Patient Profile</h5>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['patientFirstName'].id"
          [formElementModel]="formElementModels['patientFirstName']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['patientLastName'].id"
          [formElementModel]="formElementModels['patientLastName']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['patientBirthDate'].id"
          [formElementModel]="formElementModels['patientBirthDate']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['trimmedAccessionNumber'].id"
          [formElementModel]="formElementModels['trimmedAccessionNumber']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['patientMrn'].id"
          [formElementModel]="formElementModels['patientMrn']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['modality'].id"
          [formElementModel]="formElementModels['modality']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['studyType'].id"
          [formElementModel]="formElementModels['studyType']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['studyDate'].id"
          [formElementModel]="formElementModels['studyDate']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['urgency'].id"
          [formElementModel]="formElementModels['urgency']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-4 section-col">
        <app-text
          [id]="formElementModels['reportingRadiologist'].id"
          [formElementModel]="formElementModels['reportingRadiologist']"
          [parentFormGroup]="formGroup"
          [readOnly]="true"
        ></app-text>
      </div>
    </div>
    <div class="row section-row" *ngIf="showImageAvailabilityRelatedMessage">
      <p class="col section-col text-center">
        The images are not available on our system. To expedite the response,
        please resend the images (priors if applicable) for the case.
      </p>
    </div>
  </div>
</div>
